export default item => !!item.sys;



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/helpers/isLink.js